// src/pages/ContactUs.js
import React, { useRef, useState } from 'react';
import emailjs from 'emailjs-com';
import Navbar from '../components/layout/Navbar';
import SEO from '../components/SEO'; // ✅ ADD THIS
import '../styles/contact.css';

// SVG Icons
const EmailIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
    <polyline points="22,6 12,13 2,6"></polyline>
  </svg>
);

const PhoneIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
  </svg>
);

const LocationIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
    <circle cx="12" cy="10" r="3"></circle>
  </svg>
);

export default function ContactUs() {
  const formRef = useRef(null);
  const [phone, setPhone] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
    const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  // ✅ Local Business Schema
  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "College Aggregator",
    "description": "College admission guidance and information platform for Dehradun colleges",
    "url": "https://www.collegeaggregator.com",
    "telephone": "+91-XXXXXXXXXX", // ✅ TODO: Add your real phone
    "email": "info@collegeaggregator.com", // ✅ TODO: Add your real email
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Your Office Address", // ✅ TODO: Add real address
      "addressLocality": "Dehradun",
      "addressRegion": "Uttarakhand",
      "postalCode": "248001",
      "addressCountry": "IN"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "30.3165",
      "longitude": "78.0322"
    },
    "sameAs": [
      "https://www.facebook.com/collegeaggregator",
      "https://instagram.com/collegeaggregator",
      "https://www.linkedin.com/company/collegeaggregator/"
    ],
    "priceRange": "Free Consultation",
    "openingHours": "Mo-Sa 09:00-18:00"
  };

  // STRICT VALIDATION
  const validateForm = () => {
    const newErrors = {};
    const formData = new FormData(formRef.current);
    
    // Name - letters only
    const name = formData.get('name')?.trim();
    if (!name || !/^[a-zA-Z\s]+$/.test(name)) {
      newErrors.name = 'Name can only contain letters';
    }

    // Email
    const email = formData.get('email')?.trim();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = 'Please enter a valid email';
    }

    // Phone - exactly 10 digits
    if (phone.length !== 10) {
      newErrors.phone = 'Phone must be exactly 10 digits';
    }

    // City - letters only
    const city = formData.get('city')?.trim();
    if (!city || !/^[a-zA-Z\s]+$/.test(city)) {
      newErrors.city = 'City can only contain letters';
    }

    // Course
    const course = formData.get('course');
    if (!course || course === '') {
      newErrors.course = 'Please select a course';
    }

    // Qualification
    const qualification = formData.get('qualification')?.trim();
    if (!qualification) {
      newErrors.qualification = 'Please enter qualification';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrors({});

    if (!validateForm()) {
      return;
    }

    setLoading(true);

    const formData = new FormData(formRef.current);
 const templateParams = {
  name: formData.get('name'),
  email: formData.get('email'),
  phone: formData.get('phone'),
  city: formData.get('city'),
  course: formData.get('course'),
  qualification: formData.get('qualification'),
  marks: 'Not specified',
  message: formData.get('message') || 'No message',
  // ✅ FIXED: Remove duplicate
  chosen_college: formData.get('college') || 'Not specified',
  college_name: 'General - Contact Page',
  form_source: 'contact_page',
  page_url: window.location.href,
  submission_time: new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })
};

    emailjs
      .send('service_u0g0bqj', 'template_naso7ph', templateParams, '0JNndpSn5KZm_5yLJ')
      .then(() => {
        setLoading(false);
        setShowSuccess(true);
        formRef.current.reset();
        setPhone('');
        setTimeout(() => setShowSuccess(false), 5000);
      })
      .catch((error) => {
        setLoading(false);
        console.error('Error:', error);
        alert('Failed to submit. Please try again.');
      });
  };


  return (
    <>
      {/* ✅ FIXED: Add SEO component with schema */}
      <SEO 
        title="Contact Us - College Aggregator | Get Admission Guidance"
        description="Contact College Aggregator for college admission guidance, counseling, and support in Dehradun. Reach us via phone, email, or visit our office."
        keywords="contact college aggregator, admission guidance dehradun, college counseling, education consultant dehradun, college admission help"
        canonical="/contact"
        structuredData={localBusinessSchema}
      />
      
      <Navbar />
      <div className="cntcpg-wrapper">
       
        {/* --- SECTION 1: HERO BANNER --- */}
        <div className="cntcpg-hero">
          <div className="cntcpg-hero-content">
            <h1>Contact <span className="cntcpg-highlight-text">Us</span></h1>
            <p>We'd love to hear from you. Reach out to us for any queries.</p>
          </div>
          <div className="cntcpg-hero-image-container">
            <img 
              src="/images/contactuspg.webp" 
              alt="Students talking" 
              className="cntcpg-hero-img"
            />
          </div>
        </div>

        {/* --- SECTION 2: GLASS WRAPPER (Form + Map) --- */}
        <div className="cntcpg-glass-section">
          
          {/* A. CONTACT CONTAINER (Info + Form) */}
          <div className="cntcpg-container">
            
            {/* Left Side: Info Cards */}
            <div className="cntcpg-info-section">
              <h2>Get In Touch</h2>
              <p className="cntcpg-subtitle">Have questions? We are here to help.</p>
              
              <div className="cntcpg-details">
                <div className="cntcpg-item">
                  <div className="cntcpg-icon">
                    <EmailIcon />
                  </div>
                  <div>
                    <h3>Email</h3>
                    <p>collegeaggregator@gmail.com</p>
                  </div>
                </div>

                <div className="cntcpg-item">
                  <div className="cntcpg-icon">
                    <PhoneIcon />
                  </div>
                  <div>
                    <h3>Phone</h3>
                    <p>+91 80265 35439</p>
                  </div>
                 </div>

                 <div className="cntcpg-item">
                  <div className="cntcpg-icon">
                    <LocationIcon />
                   </div>
                   <div>
                    <h3>Location</h3>
                    <p>217, Lunia Lane, Paltan Bazaar, Dehradun, Uttarakhand, India</p>
                  </div>
                </div>
               </div>

               <div className="cntcpg-social-links">
                <h3>Follow Us</h3>
                <div className="cntcpg-social-icons">
                  <a href="#"><img src="https://cdn-icons-png.flaticon.com/512/733/733547.png" alt="FB" /></a>
                  <a href="#"><img src="https://cdn-icons-png.flaticon.com/512/2111/2111463.png" alt="Insta" /></a>
                  <a href="#"><img src="https://cdn-icons-png.flaticon.com/512/3536/3536505.png" alt="LinkedIn" /></a>
                </div>
              </div>
            </div>

            {/* Right Side: Glass Form */}
            <div className="cntcpg-form-section">
              <h2>Send Us a Message</h2>
              
               {!showSuccess ? (
                <form ref={formRef} className="cntcpg-form" onSubmit={handleSubmit}>
                  <div className="cntcpg-form-group">
                    <label>Full Name *</label>
                    <input 
                      name="name" 
                      type="text" 
                      required 
                      placeholder="Letters only"
                      className={errors.name ? 'error' : ''}
                    />
                    {errors.name && <p className="cntcpg-error-text">{errors.name}</p>}
                  </div>

                  <div className="cntcpg-form-group">
                    <label>Email *</label>
                    <input 
                      name="email" 
                      type="email" 
                      placeholder="Your Email"

                      required 
                      className={errors.email ? 'error' : ''}
                    />
                    {errors.email && <p className="cntcpg-error-text">{errors.email}</p>}
                  </div>

                  <div className="cntcpg-form-group">
                    <label>Mobile Number *</label>
                    <input 
                      name="phone" 
                      type="tel" 
                      value={phone}
                      maxLength="10"
                      required 
                      placeholder="Your phone number"
                      onChange={(e) => {
                        const digits = e.target.value.replace(/\D/g, '').slice(0, 10);
                        setPhone(digits);
                      }}
                      className={errors.phone ? 'error' : ''}
                    />
                    {errors.phone && <p className="cntcpg-error-text">{errors.phone}</p>}
                  </div>

                  <div className="cntcpg-form-group">
                    <label>City *</label>
                    <input 
                      name="city" 
                      type="text" 
                      required 
                      placeholder="Your City"
                      className={errors.city ? 'error' : ''}
                    />
                    {errors.city && <p className="cntcpg-error-text">{errors.city}</p>}
                  </div>

{/* ✅ ADD THIS - Choose College */}
<div className="cntcpg-form-group">
  <label>Choose College *</label>
  <select name="college" required>
    <option value="">Select a college</option>
    <option value="UPES College">UPES College</option>
    <option value="Graphic Era University">Graphic Era University</option>
    <option value="UIT College">UIT College</option>
    <option value="HIT College">HIT College</option>
    <option value="Dev Bhoomi Uttarakhand University">Dev Bhoomi Uttarakhand University</option>
    <option value="GRD College">GRD College</option>
    <option value="DD College">DD College</option>
    <option value="Sai College">Sai College</option>
    <option value="Institute Of Technology & Management">Institute Of Technology & Management</option>
    <option value="Doon Group Of Colleges">Doon Group Of Colleges</option>
    <option value="Maya Group of Colleges">Maya Group of Colleges</option>
    <option value="Not Sure">Not Sure / Need Guidance</option>
  </select>
</div>


                  <div className="cntcpg-form-group">
                    <label>Interested Course *</label>
                    <select name="course" required className={errors.course ? 'error' : ''}>
                      <option value="">Select a course</option>
                      <option value="btech">B.Tech</option>
                      <option value="mba">MBA</option>
                      <option value="bba">BBA</option>
                      <option value="bba">Other</option>
                    </select>
                    {errors.course && <p className="cntcpg-error-text">{errors.course}</p>}
                  </div>

                  <div className="cntcpg-form-group">
                    <label>Qualification *</label>

                    <input name="qualification" type="text" required placeholder="Your qualification e.g., 12th" className={errors.qualification ? 'error' : ''} />
                    {errors.qualification && <p className="cntcpg-error-text">{errors.qualification}</p>}
                  </div>

                  <div className="cntcpg-form-group cntcpg-full-width">
                    <label>Message (Optional)</label>
                    <textarea name="message" rows="3" placeholder="Any questions?"></textarea>
                  </div>

                  <button 
                    type="submit" 
                    className="cntcpg-submit-button"
                    disabled={loading}
                  >
                    {loading ? 'Submitting...' : 'Submit Application'}
                  </button>
                </form>
              ) : (
                <div className="cntcpg-success-message">
                  <h3>✓ Message Sent!</h3>
                  <p>We'll get back to you soon.</p>
                </div>
              )}
            </div>
          </div>
        
          {/* B. MAP SECTION (Inside Glass Wrapper) */}
         <div className="cntcpg-map-section">
  <iframe 
    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d440830.1182289971!2d78.040133!3d30.322936!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3909298468a10b37%3A0x4597aacdf59cd407!2sCollegeAggregator%20%7C%20Find%20Your%20Path%20to%20Success%3A%20Top%20Colleges%20in%20Dehradun%2C%20Uttarakhand!5e0!3m2!1sen!2sus!4v1765866949779!5m2!1sen!2sus"
    className="cntcpg-map-frame"
    allowFullScreen="" 
    loading="eager"
    referrerPolicy="no-referrer-when-downgrade"
    title="College Location"
    style={{ border: 0 }}
  ></iframe>
</div>

        </div>
      </div>
      

       {/* FULL-WIDTH FOOTER */}
      <footer className="site-footer">
        <div className="footer-inner">
          <div className="footer-brand">
            <h3>CollegeAggregator</h3>
            <p>
              Helping students discover the right colleges with transparent data on
              courses, fees, and placements.
            </p>
          </div>

          <div className="footer-columns">
            <div className="footer-col">
              <h4>Support</h4>
              <a href="#counselling">Free Counselling</a>
              <a href="#faqs">FAQs</a>
              <a href="#contact">Contact Us</a>
            </div>

            <div className="footer-col">
              <h4>Contact</h4>
              <p>Email: collegeaggregator@gmail.com</p>
              <p>Mon–Sat, 10am–7pm IST</p>
              <div className="footer-social">
                <a
                  href="https://www.facebook.com/collegeaggregator?mibextid=ZbWKwL"
                  target="_blank"
                  rel="noreferrer"
                >
                  FB
                </a>
                <a
                  href="https://instagram.com/collegeaggregator?igshid=ZDdkNTZiNTM="
                  target="_blank"
                  rel="noreferrer"
                >
                  IG
                </a>
                <a
                  href="https://www.linkedin.com/company/collegeaggregator/"
                  target="_blank"
                  rel="noreferrer"
                >
                  in
                </a>
                <a href="https://g.co/kgs/7wKFni" target="_blank" rel="noreferrer">
                  G
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <span>
            © {new Date().getFullYear()} CollegeAggregator. All rights reserved.
          </span>
          <div className="footer-links">
            <a href="#terms">Terms</a>
            <a href="#privacy">Privacy</a>
          </div>
        </div>
      </footer>
    </>
  );
}